module.exports = __webpack_public_path__ + "img/jfZlatni.b18fa03b.jpg";